<template>
  <div class="pie-chart-row">
    <div v-if="draw" class="pie-chart-col-6">
      <canvas class="chart" :id="`${id}`"></canvas>
    </div>
    <div v-if="draw" class="pie-chart-col-6">
      <div class="pie-chart-row detail-container">
        <div
          :key="index"
          v-for="(item, index) in data"
          :class="`top-holding-item pie-chart-col${data.length > 6 ? '-6' : '-12'} `"
        >
          <div class="color-symbol" :style="{ backgroundColor: computeColor(index)}"></div>
          <div class="top-holding-detail">
            <summary class="percent">{{ item.percent | percent }}</summary>
            <p class="title">{{ item.name || '' }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
import ColorPalettes from "../../config/color-palettes.json";

export default {
  name: "pie-chart",
  props: {
    data: {
      type: [Object, Array],
      default: null
    },
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      colorPalette: ColorPalettes.default,
      draw: true
    };
  },
  watch: {
    data() {
      if (this.data.length > 0) {
        this.draw = true;
        this.createChart(this.id, this.data);
      } else {
        this.draw = false;
      }
    }
  },
  filters: {
    percent: function(value) {
      if (value) {
        return Number(value).toFixed(0) + " %";
      }

      return "";
    }
  },
  methods: {
    createChart(chartId, chartData) {
      if (chartData) {
        var ctx = document.getElementById(chartId);
        new Chart(ctx, {
          type: "doughnut",
          data: {
            datasets: [
              {
                data: chartData.map(item => {
                  return item.percent;
                }),
                backgroundColor: this.getColorPalette(chartData.length)
              }
            ],
            labels: chartData.map(item => {
              return item.name;
            })
          },
          options: {
            legend: {
              display: false
            },
            layout: {
              padding: {
                left: 50,
                right: 50,
                top: 0,
                bottom: 0
              }
            },
            tooltips: {
              callbacks: {
                label: (tooltipItem, data) => {
                  let index = tooltipItem.index;
                  return (
                    data.labels[index] +
                    " : " +
                    data.datasets[0].data[index] +
                    "%"
                  );
                }
              }
            }
          },
          plugins: [
            {
              afterDatasetsDraw: function(chart) {
                //Get ctx from string
                let ctx = chart.ctx;
                //Get options from the center object in options
                let sidePadding = 20;
                let sidePaddingCalculated =
                  (sidePadding / 100) * (chart.innerRadius * 2);
                let elementWidth =
                  chart.innerRadius * 2 - sidePaddingCalculated;

                let centerX =
                  (chart.chartArea.left + chart.chartArea.right) / 2;
                let centerY =
                  (chart.chartArea.top + chart.chartArea.bottom) / 2;

                ctx.globalAlpha = 0.5;
                ctx.beginPath();
                ctx.arc(centerX, centerY, elementWidth * 0.7, 0, 2 * Math.PI);
                ctx.fillStyle = "white";
                ctx.fill();
                ctx.globalAlpha = 1;
              }
            }
          ]
        });
      }
    },
    getColorPalette(num) {
      let returnList = [];
      let colorPalette = this.colorPalette;

      for (let i = 0; i < num; i++) {
        returnList.push(colorPalette[i % colorPalette.length]);
      }
      return returnList;
    },
    computeColor(num) {
      let colors = this.colorPalette;
      return this.colorPalette[num % colors.length] || "";
    }
  }
};
</script>

<style lang="scss" scoped>
.chart {
  margin-bottom: 24px;
}

.top-holding-item {
  position: relative;
  margin: 0px;
  padding: 0px;

  .color-symbol {
    position: absolute;
    left: 0;
    top: calc(50% - 6px);
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }

  .top-holding-detail {
    margin-left: 24px;

    .percent {
      display: inline-block;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: $color-secondary;
      margin-right: 10px;
    }

    .title {
      display: inline-block;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: $color-secondary;
    }
  }
}
.pie-chart-row {
  display: block;

  .detail-container {
    padding: 16px 32px;
  }
}
</style>
